import React, { useState } from "react";
import { Plus } from "lucide-react";
import { CHEATSHEET_BLOCKS } from "./cheatsheetConstants";

export default function CheatsheetBlockEditorPanel({
                                                       onAddBlock
                                                   }) {
    const [open, setOpen] = useState(false);

    return (
        <div className="flex justify-between items-center mb-5">

            <h2 className="font-bold text-lg">
                بلاک‌ها
            </h2>

            <div className="relative">

                <button
                    type="button"
                    onClick={() => setOpen(v => !v)}
                    className="px-4 py-2 rounded-xl bg-blue-600 text-white flex items-center gap-2"
                >
                    <Plus size={16} />
                    افزودن بلاک
                </button>

                {open && (
                    <div className="absolute right-0 mt-2 w-56 bg-white border rounded-xl shadow-lg z-20">

                        {CHEATSHEET_BLOCKS.map(block => (
                            <button
                                key={block.type}
                                type="button"
                                onClick={() => {
                                    onAddBlock(block.type);
                                    setOpen(false);
                                }}
                                className="block w-full text-right px-4 py-2 hover:bg-gray-100"
                            >
                                {block.label}
                            </button>

                        ))}

                    </div>
                )}

            </div>

        </div>
    );
}